<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Vendor Reject List</strong> 
           
          </div>
       
          <b-row>
       
         <b-col md="12" >

         </b-col>
         <div id="overlay" >
             <div class="loader"></div>
           </div>
         <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
               <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>
              </b-col> 
              
                <b-col sm="12" class="text-left">
                    
                  <b-button style="margin-left: 25px; " id="printbutton" variant="primary" size="md" value="print a div!" @click="barcodedata('printableArea')">Print Rack</b-button>


                </b-col>
              
   



          <b-col md="12" >
        
            <div class="tab-panel" >
             <b-table show-empty stacked="md"  :items="itemslist" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="actions" slot-scope="row">
             
                 <b-button size="sm" @click="productinfoModal(row.item)" class="mr-1">
                    Product Info
                  </b-button>
                
                </template>

        
          </b-table>
         
                       <div id="printableArea" style="display:none;" >
       <!--  <span><b>{{this.activeTab}}</b></span> -->
         <span ><b>Vendor Reject</b></span>
         <barcode v-bind:value="135">
                        
                          </barcode>
            
          </div>
            </div>
                <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> 

          

            
          
             </b-col>
              <b-modal title=" Product Info" v-model="productDetails" @ok="productDetails = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5> Product Info</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
            
               
              
    <b-table show-empty stacked="md"  :items="productlist" :busy="isBusy"    :current-page="currentPage"  :fields="productfields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
           

        
          </b-table>
               
                  
              
               

                     

                 
                <div slot="footer" class="text-right">
                  <!-- <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="productcancel(); ">cancel</b-button>
                </div>
              
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 
         
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   

</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import VueBarcode from 'vue-barcode';


export default {
  data: function() {
    return {
       
        isBusy: false,
       
          
        fields: [
          { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc' },
          { key: 'deliverystatus', label: 'Status', sortable: true, sortDirection: 'desc' },
            { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
          { key: 'vendor_name', label: 'Vendor Name', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'pick up Address', sortable: true, sortDirection: 'desc' },
          { key: 'shipaddress1', label: 'Shipping Address', sortable: true, sortDirection: 'desc' },
        
          
          { key: 'deliverystatusname', label: 'Delivery Status Reason', sortable: true, sortDirection: 'desc' },
          { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass'},
          
          
        
       ], 
         productfields: [
          { key: 'productid', label: 'Product Id', sortable: true, sortDirection: 'desc' },
          { key: 'productname', label: 'Produt Title', sortable: true, sortDirection: 'desc' },
            
          { key: 'productquantity', label: 'Quantity', sortable: true, sortDirection: 'desc' },
          { key: 'productvalue', label: 'Price', sortable: true, sortDirection: 'desc' },
          
           ], 
       add: true,
      rackno:'',
       productDetails:false,
       items:[],
       itemslist:[],
       productlist:[],
       bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        filter: null,
        sortDesc: false,
        sortDirection: 'desc',
        activeTab: '',
        activeTabName: '',
    
      name: 'exceptionReport'
    };
  },
  components: {
    'barcode': VueBarcode
  },
  
  created: function() {

    
     this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
  
  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
  
      downloadCSV: function() {
document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
// alert("working");
 const info = {
    sysusermasterid:`${userInfo.sysusermasterid}`,  
      
      }
      console.log(info);
     

 this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/displayvendorrejectlistingcsv_advanced`,info)
        .then(result => {
         console.log(result.url);
          document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
       }
       else
       {
        alert("Can not Download");
       }
       // window.location.href =result.url;
        });
        
    },

 
 //     downloadCSV: function() {
     

 // this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/displayvendorrejectlistingcsv`)
 //        .then(result => {
 //         // console.log(result.url);
 //        window.location.href =result.url;
 //        });
        
 //    },

      productinfoModal: function(value) {
         //alert(value.shippingid);

         // this.isBusy = true;
          const obj = {
                shippingid:value.shippingid,
           }
    

       this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/productlisting`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.productlist  = result.body.returnvalue;
             
             // this.isBusy = !this.isBusy;
            
          } else {
            this.productlist=[];
           
               // this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
     
      this.productDetails = !this.productDetails;
      
    },
        productcancel: function() {
      
      this.productDetails = !this.productDetails;
      
    },
      barcodedata(printableArea){
 var printContents = document.getElementById("printableArea").innerHTML;

var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
      //  docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      // docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      // docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:40px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      // docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 100px;text-align: center;}');

      // docprint.document.write('.addpad{ padding: 10px; }');


       // docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

// docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        // docprint.document.write('.stickertable td{ padding-bottom:10px;line-height:1.5  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


   
  

       docprint.document.write('</head><body onLoad="self.print()"><center>');


       
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();

       

    },

     
 
    displaydata: function () {
     
 this.isBusy = true;
    

       this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/displayvendorrejectlisting`)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.itemslist  = result.body.returnvalue;
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
            
          } else {
            this.itemslist=[];
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },


  }
};
</script>
<style type="text/css">
    #overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
